export class MediaType {
  public static IMAGE = 'image';
  public static VIDEO = 'video';
  public static PDF = 'pdf';
  public static AUDIO = 'audio';
  public static UNDEFINED = 'undefined';
}
